import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import FloatCallButton from './FloatCallButton';

export default function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main style={{ paddingTop: 68 }}>
        {children}
      </main>
      <Footer />
      <FloatCallButton />
    </>
  );
}
